import { getAssetLink } from '@doltech/utils/lib/url';

export const bannerOnlineTest = {
  imgVertical: {
    src: getAssetLink({
      item: {
        handle: '3i6dHPFgQAqxjznNe0I0',
      },
    }),
    width: 1343,
    height: 2877,
    base64PlaceHolder:
      'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP88+RcPQAIwQMv9phZxgAAAABJRU5ErkJggg==',
  },
  imgHorizontal: {
    src: getAssetLink({
      item: {
        handle: '7EPpfu0QHSbo4j88CVgI',
      },
    }),
    width: 4000,
    height: 1031,
    base64PlaceHolder:
      'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP88+RcPQAIwQMv9phZxgAAAABJRU5ErkJggg==',
  },
};
